// @ts-nocheck
import { useState, useEffect } from "react"
import { graphql, Slice } from "gatsby"
import { Box, Stack, Typography } from "@mui/material"
import { get, sampleSize } from "lodash"
import { useDispatch, addNode, removeNode, useSelector } from "@ggs/store"
import Layout from "../components/layout"
import {
  Hero,
  ArticleBody,
  DynamicSubNav,
  SuggestedTrips,
  FC,
  ContactCTA,
  LeadInText,
  TripDestinationSearch,
} from "../components"
import SEOHead from "../components/head"
import {
  useStaffData,
  useTravelGuideData,
  useDynamicSubNav,
  useTripsData,
  useGeoPagesSolrData,
} from "../local/hooks"
import { mapWishlistData, mapArticleTeaser, mapGeoPageData } from "../helpers/data-mappers"

const TripIdea: FC = (props) => {
  const [contactCtaStaff, setContactCtaStaff] = useState(null)
  const [suggestedTrips, setSuggestedTrips] = useState(null)
  const [travelInformationPages, setTravelInformationPages] = useState(null)
  const [tripIdeaPages, setTripIdeaPages] = useState(null)
  const [experienceFacets, setExperienceFacets] = useState(null)
  const [experienceFilter, setExperienceFilter] = useState(null)
  const { getStaffByDestination } = useStaffData()
  const { getTripsData, getExperienceFacets } = useTripsData()
  const { getTripIdeaPages, getTravelInformationPages } = useGeoPagesSolrData()
  const wishlist = useSelector((state) => state.views.wishlist)
  const likedTrips = wishlist?.trip && wishlist?.trip.map((trip) => trip.nid)
  const userCountry = useSelector((state) => state.settings.country)

  const data = get(props, "data.nodeTripIdea", {})
  const tripIdeaTitle = get(data, "title", "")
  const tripIdea = mapGeoPageData(data)
  const tripIdeaCountry = get(tripIdea, "country[0]", null)
  const tripIdeaDestination = get(tripIdeaCountry, "destinations[0]", null)
  const refDestinationId = get(tripIdeaDestination, "external_id", "")

  // Resolve Solr data.
  useEffect(() => {
    getStaffByDestination(refDestinationId).then((data) => {
      setContactCtaStaff(data as any)
    })
    // get trip idea links
    getTripIdeaPages(tripIdeaCountry.external_id).then((data) => {
      setTripIdeaPages(data)
    })
    // get travel information links
    getTravelInformationPages(tripIdeaCountry.external_id).then((data) => {
      setTravelInformationPages(data)
    })
    // get experience facets
    if (tripIdeaCountry) {
      getExperienceFacets(tripIdeaCountry.external_id).then((data) => {
        setExperienceFacets(data?.data)
      })
    }
  }, [])

  useEffect(() => {
    if (experienceFacets) {
      const matchingExperience = experienceFacets.find(
        (experience) => experience.name === tripIdeaTitle
      )
      setExperienceFilter(matchingExperience || null)
    }
  }, [experienceFacets])

  const subNav = useDynamicSubNav({
    title: tripIdeaCountry?.title || "Overview",
    uri: tripIdeaCountry?.slug,
    nid: tripIdeaCountry?.external_id,
  })

  if (!tripIdea) {
    return null
  }

  const { hero, contact_cta, lead_in_text } = tripIdea

  return (
    <>
      {ComposeHead(props)}
      <Layout
        hero={
          <Hero
            title={hero?.title}
            subtitle={hero?.subtitle || "Trip Ideas"}
            media={hero?.images}
            subtitleImageUrl={hero?.subtitleImageUrl}
            video={hero?.video}
            path={hero?.breadcrumbs}
            isTripIdea
          />
        }
      >
        {subNav && (
          <DynamicSubNav
            links={subNav}
            travelInformation={travelInformationPages}
            tripIdea={tripIdeaPages}
            countryId={tripIdeaCountry.external_id}
            activeLink={"Vacation Packages"}
          />
        )}
        {lead_in_text && <LeadInText text={lead_in_text} />}
        {tripIdea.body && (
          <Box mb={{ xs: 15, md: 20 }}>
            <ArticleBody layout="guide" description={tripIdea?.body} isGeoPage isExpandable />
          </Box>
        )}
        <TripDestinationSearch
          location={tripIdeaCountry.external_id}
          path={tripIdea.slug}
          experienceFilter={experienceFilter}
        />
        <ContactCTA
          title={contact_cta?.title}
          subtitle={contact_cta?.subtitle}
          description={contact_cta?.description}
          link={contact_cta?.link}
          image={contact_cta?.image}
          staff={contactCtaStaff}
        />
        <Slice alias="preFooterStyle2" destinationId={refDestinationId} />
      </Layout>
    </>
  )
}

export default TripIdea

export const ComposeHead = (props: any) => {
  const { nodeTripIdea } = props.data
  const metatag = get(nodeTripIdea, "metatag.items")
  const url = get(nodeTripIdea, "slug")
  const image = get(nodeTripIdea, "hero.images[0].variants[0].url")
  return <SEOHead metas={metatag} url={url} image={image} />
}

export const query = graphql`
  query TripIdeaQuery($id: String!) {
    nodeTripIdea(id: { eq: $id }) {
      id
      slug
      title
      external_id
      body
      lead_in_text
      metatag {
        items {
          content
          name
        }
      }
      hero {
        ...HeroFragment
      }
      contact_cta {
        ...ContactCtaFragment
      }
      country {
        title
        id
        external_id
        slug
        destinations {
          title
          slug
          external_id
        }
        suggested_trips {
          title
          subtitle
        }
      }
      user {
        ...UserData
      }
    }
  }
`
